import { timeModel } from '~/models';
import { matchOverviewStatus } from './RecentAgreements.utils';
export function mapOverviewItemToRow(item, texts) {
    const display = resolveDisplay(item, texts);
    if (display == null) return null;
    const refs = resolveRefs(item);
    return {
        id: item.id,
        title: item.title,
        status: item.status,
        badgeLabel: display.badgeLabel,
        badgeSkin: display.badgeSkin,
        secondaryLine: display.secondaryLine,
        relationshipId: refs.relationshipId,
        draftId: refs.draftId,
        progressStatus: refs.progressStatus
    };
}
function resolveRefs(item) {
    return matchOverviewStatus(item.status, {
        active: ()=>refsWithoutProgress(item.active),
        paymentConnected: ()=>refsWithProgress(item.paymentConnected),
        reviewed: ()=>refsWithProgress(item.reviewed),
        sent: ()=>refsWithProgress(item.sent),
        scheduled: ()=>refsWithoutProgress(item.scheduled),
        draft: ()=>refsWithoutProgress(item.draft)
    });
}
function refsWithoutProgress(variant) {
    return {
        relationshipId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.relationshipId),
        draftId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.draftId),
        progressStatus: null
    };
}
function refsWithProgress(variant) {
    var _ref;
    return {
        relationshipId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.relationshipId),
        draftId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.draftId),
        progressStatus: (_ref = variant === null || variant === void 0 ? void 0 : variant.progressStatus) !== null && _ref !== void 0 ? _ref : null
    };
}
function blankToNull(value) {
    return value == null || value === '' ? null : value;
}
function resolveDisplay(item, texts) {
    const { badge, secondary } = texts;
    return matchOverviewStatus(item.status, {
        active: ()=>item.active == null ? null : {
                badgeLabel: badge.active(),
                badgeSkin: 'success',
                secondaryLine: secondary.active({
                    date: timeModel.formatDateLong(item.active.effectiveDate)
                })
            },
        paymentConnected: ()=>item.paymentConnected == null ? null : greyDisplay(badge.paymentConnected(), secondary.paymentConnected({
                date: timeModel.formatDateLong(item.paymentConnected.at)
            })),
        reviewed: ()=>item.reviewed == null ? null : greyDisplay(badge.reviewed(), secondary.reviewed({
                date: timeModel.formatDateLong(item.reviewed.at)
            })),
        sent: ()=>item.sent == null ? null : greyDisplay(badge.sent(), resolveSentLine(item.sent, secondary)),
        scheduled: ()=>item.scheduled == null ? null : greyDisplay(badge.scheduled(), secondary.scheduled({
                date: timeModel.formatDateLong(item.scheduled.at)
            })),
        draft: ()=>item.draft == null ? null : greyDisplay(badge.draft(), secondary.draft({
                name: item.draft.lastModifiedBy || secondary.unknownUser(),
                date: timeModel.formatDateLong(item.draft.lastModifiedAt)
            }))
    });
}
function greyDisplay(badgeLabel, secondaryLine) {
    return {
        badgeLabel,
        badgeSkin: 'default',
        secondaryLine
    };
}
function resolveSentLine(sent, secondary) {
    if (sent.expiresAt == null) {
        return secondary.sent({
            date: timeModel.formatDateLong(sent.sentAt)
        });
    }
    return secondary.sentWithExpiry({
        sentDate: timeModel.formatDateLong(sent.sentAt),
        expiresDate: timeModel.formatDateLong(sent.expiresAt)
    });
}
